import { Navigate, useSearchParams } from 'react-router'

export default function () {
  const [params] = useSearchParams()
  const search = params.toString()
  return <Navigate to={`/sign-up${search ? `?${search}` : ''}`} replace />
}
